import { render, staticRenderFns } from "./Seguros.vue?vue&type=template&id=2b4376d1&scoped=true&"
import script from "./Seguros.vue?vue&type=script&lang=js&"
export * from "./Seguros.vue?vue&type=script&lang=js&"
import style0 from "./Seguros.vue?vue&type=style&index=0&id=2b4376d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4376d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAutocomplete,VCard,VCol,VContainer,VSimpleTable})
